import { render, staticRenderFns } from "./ListProcess.vue?vue&type=template&id=1153faaa"
import script from "./ListProcess.vue?vue&type=script&lang=js"
export * from "./ListProcess.vue?vue&type=script&lang=js"
import style0 from "./ListProcess.vue?vue&type=style&index=0&id=1153faaa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports